import { useTranslation } from 'react-i18next';
import { Link, Text } from '@bn-apps/design-system-ui-react';
import { Container, PageHeader } from '@bn-apps/dim-ui-react';
import helpArticles from '@config/helpArticles';
import { NavigationCard } from '@components/common/NavigationCard';
import styles from './HelpSection.module.scss';
import appStyles from '@/App.module.scss';

const HelpSection = () => {
  const { t } = useTranslation();

  return (
    <Container className={appStyles.pageContent}>
      <div className="bn-mbe-800">
        <PageHeader title={t('help.title')} lead={t('help.ingress')} />
        <Text fontSize='sm' textWrapping='break-normal' className="bn-mbs-400">
          {t('help.contactPrompt')}{' '}
          <Link href={`mailto:${t('help.content.support.emailDesc')}`}>
            {t('help.contactAction')}
          </Link>
        </Text>
      </div>

      <div className="bn-mbe-2000" aria-label={t('help.quickNavLabel')}>
        <nav className={styles.quickNav}>
          <ul>
            {helpArticles.map((article) => (
              <li key={article.id}>
                <NavigationCard
                  color="blue"
                  to={article.path}
                  heading={t(`help.${article.id}`)}
                  description={t(`help.descriptions.${article.id}`)}
                />
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </Container>
  );
};

export default HelpSection;
